import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './property1-desktop.module.scss';
import { Property1DesktopType } from '@/types/footer.types';
import Link from 'next/link';

const RequestQuoteFooter: NextPage<Property1DesktopType> = ({
  className = '',
  property1 = 'Desktop',
}) => {
  return (
    <footer
      className={[styles.property1desktop, className].join(' ')}
      data-property1={property1}
    >
      <section className={`${styles.headerTop}`}>
        <div className="container">
          <div className={styles.section1}>
            <div className={styles.RequestQuoteCopyright}>
              Copyright 2025 <Link href="/">Hera Flight</Link> | All Rights
              Reserved. <Link href="/privacy-policy">Privacy Policy </Link>
            </div>
            <div className={styles.rightcol}>
              <div className={styles.socials}>
                <a
                  href="https://instagram.com/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="Instagram"
                    src="/img/footer/insta.svg"
                  />
                </a>
                <a
                  href="https://facebook.com/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="Facebook"
                    src="/img/footer/fb.svg"
                  />
                </a>
                <a
                  href="https://linkedin.com/company/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="LinkedIn"
                    src="/img/footer/linkedin.svg"
                  />
                </a>
                <a
                  href="https://twitter.com/heraflight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <Image
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt="X (Twitter)"
                    src="/img/footer/x1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <SubFooter /> */}
    </footer>
  );
};

export default RequestQuoteFooter;
